import Vue from 'vue';
import VueRouter from 'vue-router';
import Search from '../components/Search.vue';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Search',
      component: Search,
      meta: {
        title: 'Den Udvidede Danske Ordbog',
      },
    },
  ],
});
